import { Routes, Route } from "react-router-dom";
import Calls from "./Calls";

const index = () => {
	return (
		<Routes>
			<Route index element={<Calls />} />
		</Routes>
	);
};

export default index;
